'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RoleCode$() {
  this.c93 = null;
  this.c94 = false;
  this.c91 = null;
  this.c92 = false;
}
export { $c_Lpresto_types$RoleCode$ as $c_Lpresto_types$RoleCode$ };
$p = $c_Lpresto_types$RoleCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RoleCode$;
/** @constructor */
function $h_Lpresto_types$RoleCode$() {
}
export { $h_Lpresto_types$RoleCode$ as $h_Lpresto_types$RoleCode$ };
$h_Lpresto_types$RoleCode$.prototype = $p;
$p.cs7 = (function() {
  if ((!this.c94)) {
    this.c93 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c94 = true;
  }
  return this.c93;
});
$p.kw = (function() {
  if ((!this.c92)) {
    this.c91 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c92 = true;
  }
  return this.c91;
});
var $d_Lpresto_types$RoleCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RoleCode$, "presto.types$RoleCode$", ({
  a11: 1,
  D: 1
}));
export { $d_Lpresto_types$RoleCode$ as $d_Lpresto_types$RoleCode$ };
var $n_Lpresto_types$RoleCode$;
function $m_Lpresto_types$RoleCode$() {
  if ((!$n_Lpresto_types$RoleCode$)) {
    $n_Lpresto_types$RoleCode$ = new $c_Lpresto_types$RoleCode$();
  }
  return $n_Lpresto_types$RoleCode$;
}
export { $m_Lpresto_types$RoleCode$ as $m_Lpresto_types$RoleCode$ };
//# sourceMappingURL=presto.types$-Role-Code$.js.map
